import React from "react";

import { postRequest } from "../../utils/apiHandlers";

const EMPTY = {
  name: "",
  email: "",
  subject: "",
  message: "",
  website: "", //Honeypot
};

//"Contact Us" form - emailed to the guesthouse (Mail:NotifyEmail). Wix only had placeholders - the labels are now
//kept for screen readers too
const ContactForm = ({ successText }) => {
  const [form, setForm] = React.useState(EMPTY);
  const [isSending, setIsSending] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [isSent, setIsSent] = React.useState(false);

  const update = (prop) => (e) => {
    setForm({ ...form, [prop]: e.target.value });
    setIsSent(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorText("");
    setIsSending(true);
    try {
      await postRequest("/Contact/SendMessage", form);
      setIsSent(true);
      setForm(EMPTY);
    }
    catch (err) {
      setErrorText(err.message);
    }
    setIsSending(false);
  };

  const field = (prop, label, props) => (
    <label className={"contact-field"}>
      <span className={"visually-hidden"}>{label}</span>
      {prop === "message" ? (
        <textarea
          value={form[prop]}
          onChange={update(prop)}
          placeholder={label}
          {...props}
        />
      ) : (
        <input
          value={form[prop]}
          onChange={update(prop)}
          placeholder={label}
          {...props}
        />
      )}
    </label>
  );

  return (
    <form
      className={"contact-form"}
      onSubmit={onSubmit}
    >
      {field("name", "Name", { type: "text", required: true, maxLength: 200, autoComplete: "name" })}
      {field("email", "Email", { type: "email", required: true, maxLength: 200, autoComplete: "email" })}
      {field("subject", "Subject", { type: "text", maxLength: 300 })}
      {field("message", "Message", { required: true, maxLength: 5000, rows: 5 })}

      <label
        className={"form-honeypot"}
        aria-hidden={"true"}
      >
        Website
        <input
          type={"text"}
          value={form.website}
          onChange={update("website")}
          tabIndex={-1}
          autoComplete={"off"}
        />
      </label>

      <div className={"contact-form-footer"}>
        <p
          className={`contact-form-message ${errorText ? "is-error" : ""}`}
          role={errorText ? "alert" : "status"}
        >
          {errorText || (isSent ? successText : "")}
        </p>
        <button
          type={"submit"}
          className={"contact-submit"}
          disabled={isSending}
        >
          {isSending ? "Sending..." : "Submit"}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
